<template>
  <div>
    <site-app-bar></site-app-bar>

    <site-nav></site-nav>
    <v-content class="white">
      <slot></slot>
    </v-content>

    <v-footer color="primary" dark class="py-2 justify-center">
      <v-row justify="center" dense>
        <v-btn text href="https://loop-info.web.app/policy" target="_blank" x-large color="primary darken-4">이용약관</v-btn>
        <v-btn text href="https://loop-info.web.app/privacy" target="_blank" x-large color="primary darken-4">개인정보처리방침</v-btn>
        <v-btn text href="https://loop-info.web.app/notice" target="_blank" x-large color="primary darken-4">공지사항</v-btn>
        <v-col cols="12" class="d-flex justify-center">
          ©COPYRIGHT LOOP.
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
export default {

}
</script>
